<div class="d-flex flex-wrap align-items-center gap-2 mb-2" [attr.aria-label]="'savedViews.title' | translate" [attr.aria-busy]="loading">
  <button type="button" class="btn btn-primary btn-sm" [disabled]="loading"
    [attr.aria-label]="'savedViews.add' | translate" (click)="configure(editor, null)">
    <i class="fas fa-plus" aria-hidden="true"></i>
  </button>
  <button type="button" class="btn btn-sm" [ngClass]="selectedId === null ? 'btn-primary' : 'btn-outline-primary'"
    [attr.aria-pressed]="selectedId === null" (click)="select(null)">
    {{ 'savedViews.standard' | translate }}
  </button>
  @for (view of views; track view.id) {
    <div class="btn-group btn-group-sm">
      <button type="button" class="btn" [ngClass]="selectedId === view.id ? 'btn-primary' : 'btn-outline-primary'"
        [attr.aria-pressed]="selectedId === view.id" (click)="select(view)">
        {{ view.name }}
        @if (view.isDefault) { <i class="fas fa-star ms-1" [attr.aria-label]="'savedViews.default' | translate"></i> }
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="configure(editor, view)"
        [attr.aria-label]="('savedViews.edit' | translate) + ' ' + view.name">
        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
      </button>
    </div>
  }
  @if (error && !saving) { <span class="text-danger" role="alert">{{ 'savedViews.error' | translate }}</span> }
</div>

<ng-template #editor let-dialog>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'savedViews.configure' | translate }}</h5>
    <button type="button" class="btn-close" [disabled]="saving" (click)="dialog.dismiss()" [attr.aria-label]="'savedViews.close' | translate"></button>
  </div>
  <form (ngSubmit)="save()" #viewForm="ngForm">
    <div class="modal-body">
      <label for="saved-view-name" class="form-label">{{ 'savedViews.name' | translate }}</label>
      <input id="saved-view-name" name="name" class="form-control" [(ngModel)]="name" required maxlength="100"
        [placeholder]="'savedViews.placeholder' | translate" [disabled]="saving" ngbAutofocus>
      <div class="form-check mt-3">
        <input id="saved-view-default" name="isDefault" class="form-check-input" type="checkbox" [(ngModel)]="isDefault" [disabled]="saving">
        <label for="saved-view-default" class="form-check-label">{{ 'savedViews.default' | translate }}</label>
      </div>
      <p class="text-muted small mt-2 mb-0">{{ 'savedViews.defaultHelp' | translate }}</p>
      @if (error) { <p class="text-danger mt-2" role="alert">{{ 'savedViews.error' | translate }}</p> }
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="saving || viewForm.invalid || !name.trim()">
        {{ (editing ? 'savedViews.update' : 'savedViews.create') | translate }}
      </button>
      @if (editing) {
        <button type="button" class="btn btn-outline-primary" (click)="save(true)" [disabled]="saving || viewForm.invalid || !name.trim()">{{ 'savedViews.copy' | translate }}</button>
        <button type="button" class="btn btn-outline-danger ms-auto" (click)="remove()" [disabled]="saving">{{ 'savedViews.delete' | translate }}</button>
      }
    </div>
  </form>
</ng-template>
